<template>

  <div class="job-results">
    <div class="result-item-wrapper">
      <div class="result-item">

        <div class="job-info">
          <div class="job-image-title">
            <div class="image_wrapper" data-testid="directions-64">
              <el-avatar :size="'small'" shape="square" :src="userData.image" v-if="userData.image" />
              <el-avatar :size="'small'" class="avatar-job" shape="square"
                icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
            </div>
            <div class="job-detail-main">
              <div class="job-title">{{ job.title }}</div>
              <div class="job-poster">{{ job.platformRoleName }}</div>
            </div>

            <div class="day_info_block_btn">
              <el-button class="button_more job-share-button outlined" @click="share(job.id)"
                data-testid="share-pharmacy-btn">
                <i class="el-icon-share"></i>
              </el-button>
              <el-button class="text-only" type="transparent" data-testid="directions-5" @click="bottomDropUp = true">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.99992 2.5C9.08325 2.5 8.33325 3.25 8.33325 4.16667C8.33325 5.08333 9.08325 5.83333 9.99992 5.83333C10.9166 5.83333 11.6666 5.08333 11.6666 4.16667C11.6666 3.25 10.9166 2.5 9.99992 2.5ZM9.99992 14.1667C9.08325 14.1667 8.33325 14.9167 8.33325 15.8333C8.33325 16.75 9.08325 17.5 9.99992 17.5C10.9166 17.5 11.6666 16.75 11.6666 15.8333C11.6666 14.9167 10.9166 14.1667 9.99992 14.1667ZM9.99992 8.33333C9.08325 8.33333 8.33325 9.08333 8.33325 10C8.33325 10.9167 9.08325 11.6667 9.99992 11.6667C10.9166 11.6667 11.6666 10.9167 11.6666 10C11.6666 9.08333 10.9166 8.33333 9.99992 8.33333Z"
                    fill="black" />
                </svg>
              </el-button>

            </div>
          </div>
        </div>
        <div class="job-detail-row-item">
          <LocationIcon />
          <div class="job-detail-text">
            {{ job.location }}
          </div>
        </div>
        <div class="d-flex align-items-end">
          <div class="d-flex gap-3 flex-column">
            <div class="job-detail-row-item">
              <ClockIcon />
              <div class="job-detail-text">
                {{ job.type }}
              </div>
            </div>
            <div class="job-detail-row-item" v-if="job.expiryDate">
              <ClockIcon />
              <div class="job-detail-text">
                {{ formatExpiryDate(job.expiryDate) }}
              </div>
            </div>
          </div>
          <div class="job-detail-link ml-auto" v-if="job.description"
            :class="{ 'stickToBottom': isCardExpanded === true }" data-testid="directions-6" @click="toggleCard">
            <button class="text-only">
              {{ isCardExpanded ? 'Read Less' : 'Read More' }}
            </button>
          </div>
        </div>
        <div class="badge-wrapper">
          <div class="badge-pharmacy cursor-pointer federal-support" v-if="job.federalPharmacistSupport && isUS">

            <div v-if="job.federalPharmacistSupport === 1">Federal Pharmacist Support</div>
          </div>
          <div class="badge-pharmacy cursor-pointer" :class="isJobApplied ? 'badge-applied ' : '' + job.jobStatus"
            @click="isJobApplied ? showJobApplicants(job.id) : () => ''">
            {{ job.jobStatus }}
          </div>

        </div>

        <div class="card-content" v-show="isCardExpanded">
          <!-- <div v-if="!isCardExpanded">
            {{ job.shortDescription }}...
          </div> -->
          <div v-html="job.description">
          </div>
        </div>
      </div>
    </div>
  </div>
  <el-drawer custom-class="bottom_drop_up menu-list mini-drawer" v-model="bottomDropUp" :append-to-body="true"
    :with-header="false" :direction="'btt'" :destroy-on-close="true">
    <el-button type="transparent" class="menu_item" data-testid="directions-7" @click="editJob(job.id)">
      <img src="@/assets/img/job-seeker/edit.svg" height="18" alt="" />
      Edit
    </el-button>
    <el-button v-if="job.isExpired" type="transparent" class="menu_item" data-testid="republish-job"
      @click="republishJob(job.id)">
      <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z" stroke="#0B359A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10 5V10L13.3333 11.6667" stroke="#0B359A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Republish
    </el-button>
    <el-button type="transparent" class="menu_item" data-testid="directions-8" @click="externallyFilledJob()">
      <img src="@/assets/img/job-seeker/archive.svg" height="18" alt="" />
      Externally Filled
    </el-button>
    <el-button type="transparent" class="menu_item" data-testid="directions-9" @click="withdrawJob()">
      <img src="@/assets/img/job-seeker/withdraw.svg" height="18" alt="" />
      Withdraw
    </el-button>
    <el-button type="transparent" class="menu_item" data-testid="directions-9" @click="openCloseDrawer()">
      <img src="@/assets/img/job-seeker/close-job.svg" height="18" alt="" />
      Close Job
    </el-button>
  </el-drawer>
  <el-drawer custom-class="bottom_drop_up menu-list mini-drawer header-with-only-close" :with-header="false"
    v-model="bottomDropUpClose" :destroy-on-close="true" :append-to-body="true" :direction="'btt'">
    <button class="icon-button close-button bg-transparent" @click="closeDialog">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
          fill="black" />
      </svg>
    </button>
    <!-- <el-drawer custom-class="bottom_drop_up menu-list mini-drawer" v-model="bottomDropUpClose" :append-to-body="true" :with-header="false"
    :direction="'btt'" :destroy-on-close="true" @close="closeDialog"> -->
    <el-button type="transparent" class="menu_item" data-testid="directions-7"
      @click="closeJob('No Candidate Selected')">
      <img src="@/assets/img/job-seeker/user-not-selected.svg" height="20" alt="" />
      No Candidate Selected
    </el-button>
    <el-button type="transparent" class="menu_item" data-testid="directions-8"
      @click="closeJob('Position Successfully Filled')">
      <img src="@/assets/img/job-seeker/user-check.svg" height="20" alt="" />
      Position Successfully Filled
    </el-button>
    <el-button type="transparent" class="menu_item" data-testid="directions-9"
      @click="closeJob('Filled by External Candidate')">
      <img src="@/assets/img/job-seeker/users-group.svg" height="20" alt="" />
      Filled by External Candidate
    </el-button>
    <!-- <div class="d-flex flex-col gap-4 applicant-actions-group">
      <el-button type="blue" class="primary" @click="closeDialog()">
        <span>Close</span>
      </el-button>

    </div> -->
  </el-drawer>
</template>

<script>
import { ref, computed, getCurrentInstance } from 'vue';
import { useStore } from "vuex";
import {
  useRouter,
} from "vue-router";
import { ElMessageBox, ElMessage } from "@/components/Vendor/Element";
import { isAustraliaRegion, isUSRegion } from '@/helpers/region/regionHelper.js';
import { formatExpiryDate } from '@/helpers/utility/utility.js';
import ClockIcon from '@/components/Icons/ClockIcon.vue';
import LocationIcon from '@/components/Icons/LocationIcon.vue';

export default {
  props: {
    job: Object
  },
  components: {
    ClockIcon,
    LocationIcon
  },
  setup(props) {
    const expandedCard = ref(null);
    const $store = useStore();
    const $router = useRouter();
    const userData = $store.getters.GET_USER_DATA;
    const instance = getCurrentInstance();
    const isAustralia = isAustraliaRegion();
    const isUS = isUSRegion();
    console.log("🚀 ~ setup ~ userData:", userData)
    const currentUrl = process.env.VUE_APP_CURRENT_URL;

    const toggleCard = () => {
      if (expandedCard.value === props.job.id) {
        expandedCard.value = null;
      } else {
        expandedCard.value = props.job.id;
      }
    };
    const bottomDropUp = ref(false);
    const bottomDropUpClose = ref(false);
    const isCardExpanded = computed(() => {
      return expandedCard.value === props.job.id;
    });

    const showJobApplicants = (jobId) => {
      console.log("🚀 ~ showDetail ~ jobId:", jobId)

      $router.push({
        name: "job_poster_applicants_list",
        params: { jobId: jobId } // Assuming job object has an 'id' property
      });
    };
    const openCloseDrawer = () => {
      bottomDropUp.value = false;
      bottomDropUpClose.value = true;
    };

    const closeDialog = () => {
      bottomDropUpClose.value = false;
    };

    // Computed property to check if job_status is "1 Applied"
    const isJobApplied = computed(() => {
      return props.job.jobStatus.toLowerCase().includes('applicant');
    });

    const getShortenedDescription = (description) => {
      const words = description.split(/\s+/);
      return words.length > 20 ? words.slice(0, 20).join(' ') : description;
    };

    const isDescriptionOverflow = (description) => {
      return description.split(/\s+/).length > 20;
    };

    const bottomDropUpExist = () => {
      return true;
    };

    const sendReport = () => {
      bottomDropUp.value = false;

    };

    const editJob = (jobId) => {
      console.log("🚀 ~ editJob ~ jobId:", jobId)
      $router.push({
        name: "edit_job_list",
        params: { jobId: jobId } // Assuming job object has an 'id' property
      });
    };

    const parseJobLocation = (jobLocation) => {
      if (!jobLocation) {
        return null;
      }
      if (typeof jobLocation === "string") {
        try {
          return JSON.parse(jobLocation);
        } catch (error) {
          return null;
        }
      }
      return jobLocation;
    };

    const republishJob = async (jobId) => {
      bottomDropUp.value = false;
      try {
        const response = await $store.dispatch("FETECH_JOB_DETAIL_ID", jobId);
        const jobData = response?.data?.data;
        if (!jobData || !jobData.jobTitle) {
          throw new Error("Job details are unavailable");
        }

        const questions = Array.isArray(jobData.questions)
          ? jobData.questions.map((question) => ({
            type: question.type,
            question: question.question,
            options: Array.isArray(question.options) ? [...question.options] : [],
          }))
          : [];

        const jobSkills = Array.isArray(jobData.jobSkills)
          ? jobData.jobSkills.map((skill) => ({
            label: skill.name,
            value: skill.id,
          }))
          : [];

        await $store.dispatch("clearJobListingCreatePageData");
        await $store.dispatch("setJobListingCreatePageData", {
          job_type: jobData.jobType,
          job_title: jobData.jobTitle,
          job_location: parseJobLocation(jobData.jobLocation),
          job_category: jobData.jobCategory,
          job_skills: jobSkills,
          min_rate: jobData.minRate,
          max_rate: jobData.maxRate,
          rate_type: jobData.rateType,
          bonus: jobData.bonus,
          job_description: jobData.jobDescription,
          short_description: jobData.shortDescription,
          questionary: questions.length > 0 ? "Yes" : "No",
          questions,
          platform_role_id: jobData.platformRoleId,
          hide_salary: jobData.hideSalary,
          federal_pharmacist_support: jobData.federalPharmacistSupport ?? 0,
          is_republish: true,
        });

        $router.push({
          name: "job_create_listing",
        });
      } catch (error) {
        ElMessage({
          type: "error",
          message: "Unable to republish this job ad",
        });
      }
    };


    const closeJob = async (status) => {
      await ElMessageBox.confirm(
        `Are you sure you want to close the job as <strong>${status}</strong>?`,
        "Close Job",
        {
          confirmButtonText: "Close Job",
          cancelButtonText: "Cancel",
          confirmButtonClass: "el-button--red",
          cancelButtonClass: "el-button--grey",
          showClose: false,
          dangerouslyUseHTMLString: true,
          beforeClose: (action, instance, done) => {
            if (action === 'cancel' || action === 'close') {
              closeDialog(); // Call closeDialog on cancel or close
            }
            done(); // This closes the dialog
          },
        }
      );

      await (async () => {
        try {
          const response = await $store.dispatch("CLOSE_JOB_POST", {
            jobPostId: props.job.id,
            payload: {
              reason: status
            }
          });

          if (response.data.success) {
            ElMessage({
              type: "success",
              message: response.data.message,
            });

            // Emit an event to refresh the job list
            instance.emit('refresh-job-list');
            console.log('refresh-job-list emitted');
            // TODO: Refresh the job list
          } else {
            ElMessage({
              type: "info",
              message: response.data.message,
            });
          }
          bottomDropUp.value = false;
          bottomDropUpClose.value = false;

        } catch (error) {
          ElMessage({
            type: "error",
            message: "somthing went wrong",
          });
        }
      })();
    }


    const externallyFilledJob = async () => {
      await ElMessageBox.confirm(
        `Would you like to mark this job as externally filled and close it to further applications?`,
        "Externally Filled Job",
        {
          confirmButtonText: "Close Job",
          cancelButtonText: "Cancel",
          confirmButtonClass: "el-button--red",
          cancelButtonClass: "el-button--grey",
          showClose: false,
        }
      );

      await (async () => {
        try {
          const response = await $store.dispatch("EXTERNALLY_FILLED_JOB_POST", {
            jobPostId: props.job.id
          });

          if (response.data.success) {
            ElMessage({
              type: "success",
              message: response.data.message,
            });

            // Emit an event to refresh the job list
            instance.emit('refresh-job-list');
            console.log('refresh-job-list emitted');
            // TODO: Refresh the job list
          } else {
            ElMessage({
              type: "info",
              message: response.data.message,
            });
          }
          bottomDropUp.value = false;

        } catch (error) {
          ElMessage({
            type: "error",
            message: "somthing went wrong",
          });
        }
      })();
    };

    const withdrawJob = async () => {
      await ElMessageBox.confirm(
        `Would you like to close this job ad to further applications?`,
        "Withdraw Job",
        {
          confirmButtonText: "Close Job Ad",
          cancelButtonText: "Cancel",
          confirmButtonClass: "el-button--primary",
          cancelButtonClass: "el-button--grey",
          showClose: false,
          // inputPattern:/\S.{9,}/,
          // inputErrorMessage: 'Please provide withdraw reason. (10 char min)',
          // inputPlaceholder:'Please provide reason for job withdraw.',
          focusAfterShow: true,
        }
      );

      await (async () => {
        try {
          const response = await $store.dispatch("WITHDRAW_JOB_POST", {
            jobPostId: props.job.id,
            payload: {
              reason: "Job Closed"
            }
          });

          if (response.data.success) {
            ElMessage({
              type: "success",
              message: response.data.message,
            });

            // Emit an event to refresh the job list
            instance.emit('refresh-job-list');
          } else {
            ElMessage({
              type: "info",
              message: response.data.message,
            });
          }
          bottomDropUp.value = false;

        } catch (error) {
          ElMessage({
            type: "error",
            message: error.withdrawn_reason[0],
          });
        }
      })();
    };

    const share = (id) => {

      const link = currentUrl + "job-listing/guest/job-details/" + id;
      const el = document.createElement("textarea");
      el.value = link;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      ElMessageBox.alert("Link to current job copied to clipboard", "Thanks", {
        type: "success",
        showCancelButton: false,
        confirmButtonText: "Close",
        callback: () => {
          console.log("btn click");
        },
      });
    };

    return {
      toggleCard,
      isCardExpanded,
      getShortenedDescription,
      isDescriptionOverflow,
      userData,
      bottomDropUpExist,
      bottomDropUp,
      sendReport,
      isJobApplied,
      showJobApplicants,
      withdrawJob,
      externallyFilledJob,
      editJob,
      republishJob,
      closeJob,
      openCloseDrawer,
      bottomDropUpClose,
      closeDialog,
      isAustralia,
      formatExpiryDate,
      share,
      currentUrl,
      isUS
    };
  }
};
</script>